import './Sun.css';

const sample = (min, max) => Math.random() * (max - min) + min;

export default function Sun({ nRays=12 }) {
    return (
        <div className="sunlight">
        <div className="sun">
            <div className="rays">
                {Array(nRays).fill().map((_, i) => (
                    <div key={i} className="ray" style={{
                        width: `${sample(30, 120)}vw`,
                        height: `${sample(10, 100)}px`,
                        opacity: `${sample(0.2, 0.7)}`,
                        transform: `rotate(${sample(0, 360)}deg)`,
                    }} />
                ))}
            </div>
        </div>
        {/* <div className="sunspot" /> */}
        </div>
    )
}
